import { SITE, DEFAULT_RATES, inr, RATES_COMING_SOON } from "@/lib/site";

export const Ticker = ({ rates, top = 0 }) => {
  const r = rates || DEFAULT_RATES;
  const items = [
    { label: "24KT · 999", value: r.gold_24k, testid: "gold-rate-ticker-24k" },
    { label: "22KT · 916", value: r.gold_22k, testid: "gold-rate-ticker-22k" },
    { label: "18KT", value: r.gold_18k, testid: "gold-rate-ticker-18k" },
    { label: "SILVER · 999", value: r.silver, testid: "gold-rate-ticker-silver" },
  ];
  return (
    <div
      data-testid="gold-rate-ticker"
      style={{ top }}
      className="fixed inset-x-0 z-[95] flex h-9 items-center border-b border-[#D4AF37]/10 bg-[#0B1428]/95 backdrop-blur transition-[top] duration-500"
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 overflow-x-auto px-4 font-mono text-[11px] tracking-wider whitespace-nowrap lg:px-8">
        {RATES_COMING_SOON ? (
          <div className="flex items-center gap-2" data-testid="gold-rate-ticker-soon">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#D4AF37]" />
            <span className="text-[#79756E]">TODAY&apos;S GOLD &amp; SILVER RATES</span>
            <span className="text-[#E6C265]">COMING SOON</span>
          </div>
        ) : (
          <div className="flex items-center gap-5">
            {items.map((item) => (
              <span key={item.label} data-testid={item.testid} className="flex items-center gap-2">
                <span className="text-[#79756E]">{item.label}</span>
                <span className="text-[#E6C265]">{inr(item.value)}/g</span>
              </span>
            ))}
          </div>
        )}
        <div className="hidden items-center gap-6 md:flex">
          <span className="text-[#99732B]">BIS 100% HALLMARKED</span>
          <a href={`tel:${SITE.phoneRaw}`} data-testid="ticker-phone-link" className="text-[#B5B0A8] transition-colors hover:text-[#E6C265]">
            {SITE.phoneDisplay}
          </a>
        </div>
      </div>
    </div>
  );
};
